import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const toolsStateExportReportSelector = (state: AppState) => state.map.mapSettings.data.toolsState.exportReport;
export const useToolsStateExportReportSelector = () => useSelector(toolsStateExportReportSelector);

const toolsStateExportReportIsActiveSelector = (state: AppState) => state.map.mapSettings.data.toolsState.exportReport.isActive;
export const useToolsStateExportReportIsActiveSelector = () => useSelector(toolsStateExportReportIsActiveSelector);
